import Image from '../Image';

const ModalList = ({content}) => {
  
  return (
    <div className="ModalCard">
        <div className="container-fluid">
            <div className="row align-items-center">
                <div className="col">
                    <div className="content">
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                    </div>
                    <div className="topDegrade"></div>
                    <div className="bottomDegrade"></div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default ModalList;
